<template>
  <WidgetKpiCard
    :error="!!error"
    :loading="loading"
    :lastUpdate="lastUpdate"
    @click:refresh="refresh"
    @click:table="showTable"
  >
    <template #title>
      {{ $t("widgets.orders_failed.title") }}
    </template>

    <template v-if="data" #main>
      <KpiMain
        :value="data.main.value"
        :title="dateNames.month"
        @click="onMainKpiClick"
      ></KpiMain>
    </template>

    <template v-if="data" #subs>
      <KpiSub
        :title="dateNames.prevMonth"
        :value="data.subs.month.value"
        :format="abbreviateNumber"
        :delta="data.subs.month.delta"
      ></KpiSub>
      <KpiSub
        :title="
          $t('widgets.orders_failed.turnover', { month: dateNames.month })
        "
        :value="data.subs.turnover_missed.value"
        :delta="data.subs.turnover_missed.delta"
        :format="abbreviateNumber"
      ></KpiSub>
    </template>
  </WidgetKpiCard>
</template>

<script>
import { inject } from "vue-demi";

import { useWidgetApi } from "@/composables/api/widget";
import { useRouter } from "@/composables/router";
import { usePeriodNames } from "@/composables/date";

import WidgetKpiCard from "./WidgetKpiCard.vue";
import KpiSub from "./WidgetKpiCard/KpiSub.vue";
import KpiMain from "./WidgetKpiCard/KpiMain.vue";

export default {
  components: { WidgetKpiCard, KpiSub, KpiMain },

  props: {
    hover: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const { data, lastUpdate, loading, error, execute } = useWidgetApi(
      "/dashboard/orders_failed"
    );

    const router = useRouter();

    const showTable = () => {
      router.push({
        name: "DashboardTable",
        query: { measure: "orders_failed", period: dateNames.year }
      });
    };

    const showOnMap = inject("showOnMap");

    const onMainKpiClick = () => {
      showOnMap({
        measure: "deliveryLoose"
      });
    };

    const dateNames = usePeriodNames();

    return {
      data,
      loading,
      error,
      lastUpdate,
      dateNames,

      refresh: execute,
      showTable,
      onMainKpiClick
    };
  }
};
</script>
<style></style>
